// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1tw4h","approved":"Status_approved__2MKub","rejected":"Status_rejected__2SgUU","expired":"Status_expired__2CNNF","label":"Status_label__26-nZ"};